import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

import { calendarStatus } from '../../api/calendar';
import { sendMakeupRequest } from '../../api/schedule';

const CalendarIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <rect x="3.5" y="5" width="17" height="15.5" rx="3" style={{ fill: 'none' }} />
    <path d="M8 3v4M16 3v4M3.5 10h17M12 13.5v4M10 15.5h4" style={{ fill: 'none' }} />
  </svg>
);

const RepeatIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M4 12a8 8 0 0 1 13.7-5.6L20 9" style={{ fill: 'none' }} />
    <path d="M20 4v5h-5" style={{ fill: 'none' }} />
    <path d="M20 12a8 8 0 0 1-13.7 5.6L4 15" style={{ fill: 'none' }} />
    <path d="M4 20v-5h5" style={{ fill: 'none' }} />
  </svg>
);

const isMobileDevice = () => {
  const ua = navigator.userAgent || '';

  return /Android|iPhone|iPad|iPod/i.test(ua) || (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1);
};

const ScheduleActions = ({ token }) => {
  const navigate = useNavigate();
  const [calendarConnected, setCalendarConnected] = useState(null);
  const [makeupState, setMakeupState] = useState('');

  useEffect(() => {
    let alive = true;

    if (!token) {
      return undefined;
    }

    calendarStatus({ token })
      .then((response) => {
        const data = response?.data?.data?.calendar;
        if (alive && data) {
          setCalendarConnected(Boolean(data.connected));
        }
      })
      .catch(() => {
        if (alive) setCalendarConnected(false);
      });

    return () => {
      alive = false;
    };
  }, [token]);

  const requestMakeup = async () => {
    if (makeupState === 'loading') return;

    const botWindow = isMobileDevice() ? null : window.open('', '_blank');
    setMakeupState('loading');

    try {
      const response = await sendMakeupRequest({ token });
      const data = response?.data?.data || {};
      setMakeupState(data.status || 'sent');

      if (data.bot_url) {
        if (botWindow) {
          botWindow.location.href = data.bot_url;
        } else {
          window.location.href = data.bot_url;
        }
      } else if (botWindow) {
        botWindow.close();
      }
    } catch (e) {
      if (botWindow) botWindow.close();
      setMakeupState('error');
    }
  };

  const makeupNote = {
    sent: 'Запит надіслано адміну. Відповідь прийде в Telegram-бот.',
    already_sent: 'Запит уже надіслано — адмін скоро відповість у Telegram-боті.',
    no_bot: 'Щоб надіслати запит, підключіть наш Telegram-бот — ми його відкрили.',
    error: 'Не вдалося надіслати запит. Спробуйте ще раз або напишіть у Telegram-бот.',
  }[makeupState];

  return (
    <div className="sv2-actions">
      {calendarConnected === false && (
        <button
          type="button"
          className="sv2-btn sv2-btn--calendar"
          onClick={() => navigate('/settings?highlight=google-calendar')}
        >
          <CalendarIcon />
          Додати розклад у Google Календар
        </button>
      )}
      <button type="button" className="sv2-btn sv2-btn--orange" disabled={makeupState === 'loading'} onClick={requestMakeup}>
        <RepeatIcon />
        {makeupState === 'loading' ? 'Надсилаємо…' : 'Потрібно відпрацювання'}
      </button>
      {makeupNote && <p className={`sv2-note ${makeupState === 'error' ? 'sv2-note--error' : ''}`.trim()} role="status">{makeupNote}</p>}
    </div>
  );
};

ScheduleActions.propTypes = {
  token: PropTypes.string,
};

ScheduleActions.defaultProps = {
  token: '',
};

export default ScheduleActions;
